import RoomItem from './RoomItem'
import './RoomItem.css'

export default RoomItem



// WEBPACK FOOTER //
// ./src/components/RoomItem/index.js